import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import DummyLoyaltyComponent from '../components/DummyLoyaltyComponent';
import FanCashLoyaltyComponent from '../components/FanCashLoyaltyComponent';
import {submitLoyaltyRequest, setLoyaltyAmount, setLoyaltyError} from "@v/loyalty-programs/actions/loyaltyPrograms";
import {feesSlice} from "@/slices/fees";
import { createLoadingSelector } from '@b/checkout/selectors/helpers';
import { isAuthorizedAsUser } from '@b/checkout/selectors/auth';

class LoyaltyProgramContainer extends Component {
    render() {
        // Don't render if no loyalty programs are configured
        if (!this.props.id || (this.props.type == 2 && !this.props.isAuthorized)) {
            return null;
        }

        return (
            <div className="form-card">
              {this.renderLoyaltyComponent()}
            </div>
        );
    }

    renderLoyaltyComponent = () => {
        switch (this.props.type) {
            case 1:
                return <DummyLoyaltyComponent
                  type={this.props.type}
                  id={this.props.id}
                  amountAvailable={this.props.amountAvailable}
                  updateLoyaltyAmount={this.updateLoyaltyAction}
                  amountSet={this.props.amountSet}
                  loyaltyUpdateLoading={this.props.loyaltyUpdateLoading}
                  loyaltyApplied={this.props.loyaltyApplied}
                  loyaltyErrorMessage={this.props.loyaltyErrorMessage}
                  setLoyaltyError={this.props.setLoyaltyError}
                />;
            case 2:
                return <FanCashLoyaltyComponent
                  type={this.props.type}
                  id={this.props.id}
                  amountAvailable={this.props.amountAvailable}
                  updateLoyaltyAmount={this.updateLoyaltyAction}
                  amountSet={this.props.amountSet}
                  loyaltyUpdateLoading={this.props.loyaltyUpdateLoading}
                  loyaltyApplied={this.props.loyaltyApplied}
                  loyaltyErrorMessage={this.props.loyaltyErrorMessage}
                  setLoyaltyError={this.props.setLoyaltyError}
                  loyaltyProgramLogo={"/assets/partners/fanatics/images/fanCash.svg"}
                />;
            default:
                // For unknown types, don't render anything
                return null;
        }
    };

    updateLoyaltyAction = async (loyaltyAmount) => {
      this.props.setLoyaltyError(null);
      if(loyaltyAmount*100 > this.props.amountAvailable.amount){
        this.props.setLoyaltyError("checkout__loyalty_amount_exceeds_available");
        return;
      }
      await this.props.submitLoyaltyRequest(loyaltyAmount);
      if (!this.props.loyaltyErrorMessage && loyaltyAmount) {
        this.updateLoyaltyFee(loyaltyAmount);
      }
    };

    updateLoyaltyFee = (loyaltyAmount) => {
      if (loyaltyAmount !== "") {
        this.props.setFee({type: 'loyalty', id: null, price: {amount: -loyaltyAmount}})
        this.props.setLoyaltyAmount(loyaltyAmount * 100);
      } else {
        this.props.setFee({type: 'loyalty', id: null, price: {amount: 0}})
        this.props.setLoyaltyAmount(0);
      }
    }
}

const loyaltyUpdateLoading = createLoadingSelector("LOYALTY");

const mapStateToProps = (state) => {
    return {
        type: state.loyaltyProgram ? +state.loyaltyProgram.type : null,
        id: state.loyaltyProgram ? state.loyaltyProgram.id : null,
        amountAvailable: state.loyaltyProgram ? state.loyaltyProgram.amountAvailable : null,
        amountSet: state.loyaltyProgram ? state.loyaltyProgram.amount : null,
        loyaltyApplied: state.loyaltyProgram ? state.loyaltyProgram.applied : false,
        loyaltyUpdateLoading: loyaltyUpdateLoading(state),
        loyaltyErrorMessage: state.loyaltyProgram ? state.loyaltyProgram.error : null,
        isAuthorized: isAuthorizedAsUser(state),
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
      submitLoyaltyRequest,
      setLoyaltyAmount,
      setFee: feesSlice.actions.setFee,
      setLoyaltyError,
        // Add any loyalty program actions here when needed
    }, dispatch);
};

LoyaltyProgramContainer.propTypes = {
        type: PropTypes.number.isRequired,
        id: PropTypes.string.isRequired,
        amountAvailable: PropTypes.object,
        amountSet: PropTypes.number,
};

LoyaltyProgramContainer.defaultProps = {
    type: -1,
    id: "",
    amountAvailable: {},
    amountSet: 0.00,
};

export default connect(mapStateToProps, mapDispatchToProps)(LoyaltyProgramContainer);
